import React, { useRef, useEffect } from "react";
import { Fireworks } from "fireworks-js";
import "./firework.scss";

export default function Firework({ openFirework, setIsClickedFirework }) {
  const containerRef = useRef(null);
  const fireworksInstance = useRef(null);

  useEffect(() => {
    let timer;

    if (openFirework && containerRef.current) {
      if (fireworksInstance.current) {
        fireworksInstance.current.stop();
        fireworksInstance.current = null;
      }

      fireworksInstance.current = new Fireworks(containerRef.current, {
        speed: 10,
        acceleration: 1.05,
        particles: 500,
        trace: 3,
        brightness: { min: 50, max: 80, decay: { min: 0.015, max: 0.03 } },
        sound: {
          enabled: true,
          files: [
            "https://fireworks.js.org/sounds/explosion0.mp3",
            "https://fireworks.js.org/sounds/explosion1.mp3",
            "https://fireworks.js.org/sounds/explosion2.mp3",
          ],
          volume: { min: 40, max: 60 },
        },
      });

      fireworksInstance.current.start();

      timer = setTimeout(() => {
        // Dừng tất cả âm thanh
        if (fireworksInstance.current?.sounds) {
          fireworksInstance.current.sounds.forEach(audio => audio.pause());
        }
        fireworksInstance.current.stop();
        fireworksInstance.current = null;
        setIsClickedFirework(false);
      }, 10000);
    }

    return () => {
      clearTimeout(timer);
      if (fireworksInstance.current) {
        // Dừng toàn bộ âm thanh trước khi stop
        if (fireworksInstance.current?.sounds) {
          fireworksInstance.current.sounds.forEach(audio => audio.pause());
        }
        fireworksInstance.current.stop();
        fireworksInstance.current = null;
      }
    };
  }, [openFirework]);


  return (
    <div
      ref={containerRef}
      style={{
        position: "fixed",
        width: "100%",
        height: "100%",
        top: 0,
        left: 0,
        // bottom: 200,
        zIndex: 999,
        pointerEvents: "none",
      }}
    ></div>
  );
}
